import React, { ForwardedRef, forwardRef } from 'react';
import styled from 'styled-components';
import { IconChecked } from '../icon/IconChecked';
import { Flex } from '../layout/Flex';
import { makeCheckedControl } from './makeCheckedControl';

const HiddenInput = styled.input`
    left: -50%;
    width: 200%;
    cursor: inherit;
    position: absolute;
    opacity: 0;
    height: 200%;
    top: -50%;
    margin: 0;
    padding: 0;
    z-index: 1;
`;

const Container = styled(Flex).attrs((props) => ({
    ...props,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
}))`
    display: inline-flex;
    width: 24px;
    height: 24px;
    border-radius: 8px;
    color: var(--control-secondary-color);
    background-color: var(--control-secondary-background);

    &[data-checked='true'] {
        color: var(--control-primary-color);
        background-color: var(--control-primary-background);
    }
`;

export const Checkbox = makeCheckedControl(
    forwardRef((props, ref: ForwardedRef<HTMLDivElement>) => {
        const { error, ...other } = props;

        return (
            <Container ref={ref} data-checked={props.checked}>
                <HiddenInput {...other} type="checkbox" />
                {props.checked && <IconChecked fill="currentColor" size={16} />}
            </Container>
        );
    }),
);
